module.exports = "//public.zight.com/packs/media/images/onboarding/download-windows_color-02d35985dbbd088dda9eecea655df9f7.svg";